import type { InstagramSourceValue } from '../types';

export const instagramExcludeFiltersKeys: {
  [K in keyof InstagramSourceValue]?: string;
} = {
  showCarousel: 'album',
  showImage: 'image',
  showReels: 'reel',
  showVideo: 'video'
};
